module.exports = __webpack_public_path__ + "static/img/gmhbaapp.0c2388a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gmhba/gmhbaapp.png
// module id = 581
// module chunks = 1